import { memo, useEffect, useState } from 'react';
import { UspSimple } from '~/lib/data-contract';
import styles from './usp.module.css';
import { clsx } from 'clsx';
import { CMSLink } from '~/shared/components/cms-link/cms-link.component';
import parse from 'html-react-parser';

type Props = {
    uspItems: UspSimple[];
    isAnimated?: boolean;
};

export const Usp = memo(({ uspItems, isAnimated }: Props) => {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (!uspItems || uspItems.length <= 1) return;
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % uspItems.length);
        }, 5000); // 5 seconds
        return () => clearInterval(interval);
    }, [uspItems]);

    if (!uspItems || uspItems.length === 0) return null;

    return (
        <ul className={clsx(styles.root, { [styles.animated]: isAnimated })}>
            {uspItems.map((usp, index) => (
                <li
                    key={index}
                    className={clsx(
                        styles.item,
                        { [styles.animated]: isAnimated },
                        index === activeIndex ? styles.active : styles.inactive
                    )}
                >
                    <CMSLink href={usp.link?.url} className={styles.link}>
                        {usp.text?.toUpperCase()}
                    </CMSLink>
                    {usp.description ? (
                        <span className={clsx(styles.tooltip)}>{parse(usp.description)}</span>
                    ) : null}
                </li>
            ))}
        </ul>
    );
});
